import produce from 'immer'
import { Reducer } from 'redux'
import {
  SET_ACCORDION_IS_LOADED,
  SET_DASHBOARD_IS_LOADED,
  SET_HOMEPAGE_STORIES_IS_LOADED,
  SET_HOMEPAGE_FC_UPDATES_IS_LOADED,
  SET_SEARCH_RESULTS_LOADED,
  SET_HIDE_OVERRIDE
} from 'redux/actions/types'

export interface PlaceholdersState {
  isAccordionLoaded: boolean
  isDashboardLoaded: boolean
  isHomePageStoriesLoaded: boolean
  isHomepageFcUpdatesLoaded: boolean
  isSearchResultsLoaded: boolean
  hideOverride: boolean
}

const intialState: PlaceholdersState = {
  isAccordionLoaded: false,
  isDashboardLoaded: false,
  isHomePageStoriesLoaded: false,
  isHomepageFcUpdatesLoaded: false,
  isSearchResultsLoaded: false,
  hideOverride: false
}

const placeholders: Reducer<PlaceholdersState, any> = (state = intialState, action) => {
  switch (action.type) {
    case SET_ACCORDION_IS_LOADED:
      return produce(state, draft => {
        draft.isAccordionLoaded = action.isLoaded
      })
    case SET_DASHBOARD_IS_LOADED:
      return produce(state, draft => {
        draft.isDashboardLoaded = action.isLoaded
      })
    case SET_HOMEPAGE_STORIES_IS_LOADED:
      return produce(state, draft => {
        draft.isHomePageStoriesLoaded = action.isLoaded
      })
    case SET_HOMEPAGE_FC_UPDATES_IS_LOADED:
      return produce(state, draft => {
        draft.isHomepageFcUpdatesLoaded = action.isLoaded
      })
    case SET_SEARCH_RESULTS_LOADED:
      return produce(state, draft => {
        draft.isSearchResultsLoaded = action.isLoaded
      })
    case SET_HIDE_OVERRIDE:
      return produce(state, draft => {
        draft.hideOverride = action.hideOverride
      })
    default:
      return state
  }
}

export default placeholders
